import Vue from 'vue';
import { Inertia } from '@inertiajs/inertia';
import route, { type Router as RouterBase, type RouteParamsWithQueryOverload as RouteParams } from 'ziggy-js';

import config, { type routes } from '@/routes';

type RouteName = keyof routes;
type Router = RouterBase<RouteName>;

export type { Router, RouteName, RouteParams };

export function $route<Name extends RouteName | undefined = undefined>(
  name?: Name,
  params?: Name extends string ? RouteParams : undefined,
  absolute?: boolean,
): Name extends string ? string : Router {
  return route(name, params, absolute, config);
}

export function $currentUrl(params?: RouteParams): string | undefined {
  const currentRoute = $route().current();

  return currentRoute ? $route(currentRoute, params) : undefined;
}

declare module 'vue/types/vue' {
  export interface Vue {
    $route: typeof $route;
    $currentUrl: typeof $currentUrl;
  }
}

Vue.mixin({
  methods: {
    $route,
    $currentUrl,
  },
});

Inertia.on('start', () => {
  // @todo HLCDC-255: Find a way to get rid of this condition or move it to the component itself.
  // Exclude links from the `documents/show` component to prevent looping back
  // history while navigating through document revisions.
  // And exclude `files/show` links to prevent looping back
  // history while sorting.
  if (history.state.component !== 'documents/show' && history.state.component !== 'files/show') {
    sessionStorage.setItem('prevPageUrl', history.state.url);
  }
});
